import React from 'react';
import Main from 'pages/Main';
import RenderLoadingAuthentication from 'components/RenderLoadingAuthentication';

const KeycloakAuthComponent = props => {
  const { disabled, isAuthenticated, ...rest } = props;

  if (disabled || isAuthenticated) return <Main {...rest} />;

  return <RenderLoadingAuthentication />;
};

export default KeycloakAuthComponent;
